



















































































































































































































import Vue from 'vue';
import { DataGrid } from '@questelservices/common-vue';
import { DxButton, DxAccordion } from 'devextreme-vue';
import { DxColumn, DxColumnChooser, DxEditing, DxLookup, DxStateStoring } from 'devextreme-vue/data-grid';
import { Prop, Watch, Component, Emit } from 'vue-property-decorator';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { ManualCodeInvoiceLineItemDto } from '@/models/ManualCodeInvoiceLineItemDto';
import PhaseAssignmentNotes from './phase-assignment-notes.vue';
import PhaseAssignmentInfractions from './phase-assignment-infractions.vue';
import PhaseAssignmentInfractionsPopover from './phase-assignment-infraction-popover.vue';
import { InfractionTypeDto } from '../../models/infractions/InfractionTypeDto';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { FilingTypeDto } from '../../models/FilingTypeDto';
import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import DevExpress from 'devextreme/bundles/dx.all';
import { FeeTypeEnum, FeeTypeNameEnum } from '@/models/Fees/FeeTypeEnum';
import { InfractionService } from '../../service/InfractionService';
import { UserSettingsService } from '../../service/UserSettingsService';
import { ClientAgentService } from '../../service/ClientAgentService';
import { UserSettingReportName, UserSettingName } from '@/models/UserSetting';
import { MatterWorkMatterDto } from '@/models/matter-work/MatterWorkMatterDto';
import _ from 'lodash';
import { AutoTextDataDto } from '@/models/auto-text/AutoTextDataDto';
import AgentInfoEdit from '../activity-planner/agent-info-edit.vue';
import { ClientAgentInfoDto } from '../../models/client-agent/ClientAgentInfoDto';
import { UpdateClientAgentJurisdictionDto } from '../../models/client-agent/ClientAgentJurisdictionDto';
import PhaseHistory from './phase-history.vue';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { alert } from "devextreme/ui/dialog"
import MatterWorkModule from '@/store/MatterWorkModule';
import { AnalysisReportPrintDataOptionsType } from '@/models/AnalysisReportPrintDataOptionsType';
import String from '@/utilities/String';
import UpdateLineItemsCountry from './update-line-items-country.vue';
import UpdateLineItemsMatterName from '@/components/matter-work/update-line-items-matter-name.vue';
import { ExecutiveSummaryRequestEnum } from '@/models/ExecutiveSummaryRequestEnum';
import { MatterDto } from '@/models/matter/MatterDto';

export interface MatterWorkLineItemsDialogState {
  showingContextMenu: boolean;
  showingInfractions: boolean;
  showingInfractionsPopover: boolean;
  showingNotes: boolean;
  showingColumnChooser: boolean;
  showingAgentInfo: boolean;
  showingPhaseHistory: boolean;
  showingUpdateCountry: boolean;
  showingUpdateMatterName: boolean;
}

const moment = require('moment');

@Component({
  components: {
    DataGrid,
    DxButton,
    DxColumn,
    DxColumnChooser,
    DxEditing,
    DxLookup,
    DxStateStoring,
    PhaseAssignmentNotes,
    PhaseAssignmentInfractions,
    DxCheckBox,
    DxScrollView,
    DxAccordion,
    PhaseAssignmentInfractionsPopover,
    AgentInfoEdit,
    PhaseHistory,
    UpdateLineItemsCountry,
    UpdateLineItemsMatterName
  }
})
export default class MatterWorkLineItems extends Vue {
  $refs: Vue['$refs'] & {
    manualCodingDataGrid?: DataGrid;
  } = {};
  @Prop()
  matterIdSelected!: Guid;

  @Prop()
  phaseTypes!: PhaseTypeDto[];

  @Prop()
  selectedMatter!: MatterWorkMatterDto;

  @Prop()
  filingType!: FilingTypeDto;

  @Prop({ default: undefined })
  clientId!: Guid;

  @Prop()
  latestBatchIds!: Guid[];

  get activeBatchIds() : Guid[] {
    return this.latestBatchIds;
  }

  get selectedMatterId() : Guid {
    return this.matterIdSelected;
  }

  @Prop({ default: false })
  visible!: boolean;

  get visibility() : boolean {
    return this.visible;
  }

  private matterWorkModule: MatterWorkModule = getModule(MatterWorkModule, store);

  phaseHistoryLineItemId: Guid = '';
  lineItems: ManualCodeInvoiceLineItemDto[] = [];
  selectedLineItems: ManualCodeInvoiceLineItemDto[] = [];
  infractionTypes: InfractionTypeDto[] = [];
  
  feeTypes: Array<{ value: string, text: string }> = [ 
    { value: FeeTypeNameEnum.Service, text: FeeTypeNameEnum.Service }, 
    { value: FeeTypeNameEnum.Translation, text: FeeTypeNameEnum.Translation }, 
    { value: FeeTypeNameEnum.Expense, text: FeeTypeNameEnum.Expense }
  ];
  selectedLineItem = {
    lineItemId: "",
    previousFeeType: FeeTypeNameEnum.Service
  };

  client: QuestelServicesClient;
  infractionService: InfractionService;
  userSettingsService: UserSettingsService;
  clientAgentService: ClientAgentService;  
  loadingAutoTextData: boolean = false;
  matterIdRequested: Guid = '';

  coloredColumns: Array<string> = [
    "AssignedPhaseName",
    "Description",
    "LineItemTotal",
    "PhaseCode",
    "UTBMS",
    "FeeType"
  ];

  forRequestAutoTextValue: Array<string> = [
    "[OVERCAPCOUNT]",
    "[OVERCAPCOUNTOVERAGE]",
    "[OVERTARGETCOUNT]",
    "[OVERTARGETCOUNTOVERAGE]",
    "[SUMINVOICE]",
    "[PHASEVERB]",
    "[PHASECHARGE]",
    "[PHASETOTAL]",
    "[AMOUNTOVERTARGET]",
    "[AMOUNTOVERCAP]",
    "[PHASETARGET]",
    "[PHASECAP]",
    "[OVERTARGETLIST]",
    "[OVERCAPLIST]"
  ];

  constructor() {
    super();
    this.client = new QuestelServicesClient(this.$store, '');
    this.infractionService = new InfractionService();
    this.userSettingsService = new UserSettingsService(this.$store);
    this.clientAgentService = new ClientAgentService();
  }

  async onProcessAutoText(e: string[], text: string, callback: Function){
    let autoTextContained = e;
    let selectedText = text;
    let requestedData: AutoTextDataDto | undefined = undefined;
    let hasForRequest = _.some(autoTextContained, item => this.forRequestAutoTextValue.includes(item));

    if(hasForRequest) {
      let li = this.notesLineItem.InvoiceLineItemId;
      requestedData = await this.processRequestForAutoTextData(li);
    }

    autoTextContained.forEach(item => {
      let actualData = this.processDataToDisplay(item, requestedData);

      selectedText = selectedText.split(item).join(actualData);
    })

    callback(selectedText);
  }

  processDataToDisplay(autoText: string, requestedData : AutoTextDataDto | undefined) : string {
    let result = '';
    if(autoText === "[AGENTNAME]")
    {
      result = this.notesLineItem.AgentName;
    }
    else if(autoText === "[CLIENTNAME]"){
      result = this.selectedMatter.ClientName;
    }
    else if(autoText === "[COUNTRY]"){
      result = this.selectedMatter.CountryCode;
    }
    else if(autoText === "[PHASETYPE]"){
      if (this.notesLineItem.AssignedPhaseTypeId == null) {
        result = "Blank";
      }
      else {
        result = this.notesLineItem.AssignedPhaseName;
      }      
    }
    else if(autoText === "[SERVICEDATE]"){
      result = moment(this.notesLineItem.ServiceDate).format("MM-DD-YYYY");
    }
    else if(autoText === "[INVOICEDATE]"){
      result = moment(this.notesLineItem.InvoiceDate).format("MM-DD-YYYY");
    }
    else if(autoText === "[PHASECHARGE]"){
      if (requestedData && requestedData.PhaseTotal) {
        result = (this.$options.filters as any).currencyTruncate(requestedData.PhaseCharge);
      }
    }
    else if(autoText === "[PHASETOTAL]"){
      if (requestedData && requestedData.PhaseTotal) {
        result = (this.$options.filters as any).currencyTruncate(requestedData.PhaseTotal);
      }      
    }
    else if(autoText === "[AMOUNTOVERTARGET]"){
      if (requestedData && requestedData.PhaseTarget && requestedData.PhaseCharge) {
       
        if(requestedData.PhaseCap &&
          (requestedData.PhaseCharge - requestedData.PhaseCap) > 0 ) {
            result = "NotOverTarget";
        }
        else {
          let overage = requestedData.PhaseCharge - requestedData.PhaseTarget;
          if (overage > 0) {
            result = (this.$options.filters as any).currencyTruncate(overage);
          }
          else {
            result = "NotOverTarget";
          }
        }
      }
      else {
        result = "NoTargetRuleFound";
      } 
    }
    else if(autoText === "[AMOUNTOVERCAP]"){
      if (requestedData && requestedData.PhaseCap && requestedData.PhaseCharge) {
        let overage = requestedData.PhaseCharge - requestedData.PhaseCap;
        if (overage > 0) {
          result = (this.$options.filters as any).currencyTruncate(overage);
        }
        else {
          result = "NotOverCap";
        }
        
      }
      else {
        result = "NoCapRuleFound";
      } 
    }
    else if(autoText === "[PHASEVERB]"){
      if(requestedData){
        result = requestedData.PhaseVerb ? 
          requestedData.PhaseVerb
          : '';
      }
    }
    else if(autoText === "[LINEITEMCHARGE]"){
      result = (this.$options.filters as any).currencyTruncate(this.notesLineItem.LineItemTotal);
    }
    else if(autoText === "[PHASETARGET]"){
      if (requestedData && requestedData.PhaseTarget) {
        result = (this.$options.filters as any).currencyTruncate(requestedData.PhaseTarget);
      }
      else {
        result = "NoTargetRuleFound";
      } 
    }
    else if(autoText === "[PHASECAP]"){
      if (requestedData && requestedData.PhaseCap) {
        result = (this.$options.filters as any).currencyTruncate(requestedData.PhaseCap);
      }
      else {
        result = "NoCapRuleFound";
      }      
    }
    else if(autoText === "[OVERCAPCOUNT]"){
      if(requestedData){
        result = requestedData.OverCapCount ? 
          requestedData.OverCapCount.toString()
          : 'NoneOverCap';
      }
    }
    else if(autoText === "[OVERCAPCOUNTOVERAGE]"){
      if(requestedData){
        result = requestedData.OverCapCountOverage && requestedData.OverCapCountOverage > 0? 
          (this.$options.filters as any).currencyTruncate(requestedData.OverCapCountOverage)
          : 'NotOverCap';
      }
    }
    else if(autoText === "[OVERTARGETCOUNT]"){
      if(requestedData){
        result = requestedData.OverTargetCount ? 
          requestedData.OverTargetCount.toString()
          : 'NoneOverTarget';
      }
    }
    else if(autoText === "[OVERTARGETCOUNTOVERAGE]"){
      if(requestedData){
        result = requestedData.OverTargetCountOverage && requestedData.OverTargetCountOverage > 0 ? 
          (this.$options.filters as any).currencyTruncate(requestedData.OverTargetCountOverage)
          : 'NotOverTarget';
      }
    }
    else if(autoText === "[INVOICENUMBER]"){
      result = this.notesLineItem.InvoiceNumber;
    }
    else if(autoText === "[SUMINVOICECASE]"){
      let res = _.filter(this.lineItems, i => i.InvoiceNumber === this.notesLineItem.InvoiceNumber);
      let resSum = _.sumBy(res, i => i.LineItemTotal).toString();

      result = (this.$options.filters as any).currencyTruncate(resSum);
    }
    else if(autoText === "[SUMINVOICE]"){
      if(requestedData){
        result = requestedData.SumInvoice ? 
        (this.$options.filters as any).currencyTruncate(requestedData.SumInvoice) 
        : '';
      }
    }
    else if (autoText === "[OVERTARGETLIST]") {
      if (requestedData != null) {
        if(requestedData.OverTargetList) {
          if(requestedData.OverTargetList.length > 0) {
            result = requestedData.OverTargetList.map(m => `${m.ClientMatterId}, ${m.CountryCode}`).join("<br />");
          }
          else{
            result = "NoOverageFound"
          }
        }
        else{
          result = "NoOverageFound"
        }        
      }
    }
    else if (autoText === "[OVERCAPLIST]") {
      if (requestedData != null) {
        if(requestedData.OverCapList) {
          if(requestedData.OverCapList.length > 0) {
            result = requestedData.OverCapList.map(m => `${m.ClientMatterId}, ${m.CountryCode}`).join("<br />");
          }
          else {
            result = "NoOverageFound"
          }
        }
        else{
          result = "NoOverageFound"
        }        
      }
    }

    return result;
  }

  async processRequestForAutoTextData(lineItemId: Guid): Promise<AutoTextDataDto|undefined> {
    this.loadingAutoTextData = true;
    let result = await this.client.getData<AutoTextDataDto>(HttpMethodEnum.Get,this.autoTextDataValue(lineItemId))
          .then(result => {
            return result;
          })
          .catch(err => undefined)
          .finally(() => {
            this.loadingAutoTextData = false;
          });
    return result;
  }

  private get dxDataGrid(): DevExpress.ui.dxDataGrid {
    return (this.$refs.manualCodingDataGrid as any).$refs.dxDataGrid.instance;
  }

  private get dataGridCustomStore(): DevExpress.data.CustomStore {    
    return this.dxDataGrid.getDataSource().store() as DevExpress.data.CustomStore;    
  }

  public updateLineItems(lineItems: ManualCodeInvoiceLineItemDto[]): void {       
    let updates = lineItems.map(li => { 
      return {
        type: 'update',
        key: li.InvoiceLineItemId,
        data: li
      }
    });
    
    this.dataGridCustomStore.push(updates);

    //process again the focused phase type display
    if(this.currentlyFocusedPhase) {
      this.onFocusPhaseUpdates(lineItems);
    }
  }

  onFocusPhaseUpdates(lItems: any[]) {
    lItems.forEach(li => {
      let ind = _.findIndex(this.listOfLineItems,(x : any) => li.InvoiceLineItemId === x.InvoiceLineItemId)
      if(ind != -1) {
        this.listOfLineItems[ind] = li;
      }
    });
    
    this.listOfLineItems = _.union(this.listOfLineItems, lItems);

    this.handleFocusedPhaseTypeEvent(this.currentlyFocusedPhase);
  }

  customDataSource: any[] = [];
  private get dataGridCustomStoreOption(): DevExpress.data.CustomStoreOptions {
    return {
      key: 'InvoiceLineItemId',
      loadMode: 'raw',
      onLoaded: this.dataGridLoaded,
      onUpdated: this.dataUpdated,
      onPush: this.dataPush,
      load: () => {
        this.matterIdRequested = this.selectedMatterId;

        if(this.currentlyFocusedPhase) {
          this.lineItems = this.listOfLineItems;
          return Promise.resolve(this.customDataSource);
        }
        else {
          return this.client.get<ManualCodeInvoiceLineItemDto[]>(this.matterUrl)
            .then(result => {              
              this.lineItems = result;
              return result;
            });
        }
      },
      // TODO: In the future if other columns are editable we should update this (maybe server side) to handle editing any column
      update: (key, values) => {        
        return this.updateFeeType(key, values);
      }
    }
  }

  async updateFeeType(id: Guid, feeType: FeeTypeEnum) {
    let updatedMatter = this.selectedMatter;
    return await this.client.getData(HttpMethodEnum.Patch, `/api/InvoiceLineItems/${id}/feeType`, feeType)
      .then(result => {
        return result;
      })
      .catch(_ => {
        alert(`Error updating fee type for matter ${updatedMatter!.ClientMatterId}.`, "Error");

        let lineItem = this.lineItems.filter(li => li.InvoiceLineItemId == this.selectedLineItem.lineItemId)[0];
        lineItem.FeeType = this.selectedLineItem.previousFeeType;
        return lineItem;
      });
  }

  private isContextShow: boolean = false;

  popoverTarget: string = '';
  popoverVis: boolean = false;
  draggingSelect: boolean = false;
  draggingSelection: Map<string, boolean> = new Map<string, boolean>();
  draggingSelectOrDeselect: boolean | null = true;
  draggingLastSet: string = "";

  private get matterUrl(): string {
    return `/api/manualcoding/${this.selectedMatterId}/line-items`;
  }

  private autoTextDataValue(lineItemId: Guid) : string {
    return `/api/manualcoding/auto-text-value/${this.selectedMatter.MatterWorkId}?lineItemId=${lineItemId}`;
  }

  private selectedMatterChanged: boolean = false;
  @Watch('matterUrl')
  onMatterUrlChange() {
    // Clear the current selection before advancing.
    // This was because of issues with the datagrid trying to load the previously selected data.
    this.dxDataGrid.clearSelection();
    if(this.listOfLineItems && this.listOfLineItems.length > 0) {
      this.clearFocus();
    }
    
    this.refreshDataGrid();  
    this.selectedMatterChanged = true;
  }

  private getContextMenuItems(): ContextMenuItem[] {
    return [
      {
        text: 'Set Phase',
        items: [
          ...this.getCommonPhaseTypes().map(p => this.getContextMenuItem(p)),
          {
            text: 'More',
            items: [
              ...this.getOtherPhaseTypes().map(p => this.getContextMenuItem(p)),
              {
                text: 'Clear Phase',
                onItemClick: () => this.assignPhase(null)
              }
            ]
          }
        ]
      },
      this.getContextMenuExempt(),
      this.getContextMenuChangeCountry(),
      this.getContextMenuChangeMatterName()
    ];
  }

  refreshDataGrid(): void {
    if (this.$refs.manualCodingDataGrid) {
      (this.$refs.manualCodingDataGrid as any).refreshDataGrid();
    }    
  }

  saveCellEdit(): void {
    if (this.dxDataGrid.hasEditData()) {
      this.dxDataGrid.saveEditData();
    }
  }

  dataPush(e: any) : void {
    this.updateSelectedMatterLineItems();
  }

  dataUpdated(e: any, a: any): void {
    this.updateSelectedMatterLineItems();
  }

  dataGridLoaded(result: any[]): void {
    // If the selected matter is changed before the previous line items are loaded,
    // the line items for the last selected matter aren't requested for.
    // Check if the matterId of the requested line items doesn't match the selected matter.
    if (this.selectedMatterId !== this.matterIdRequested) {
      this.refreshDataGrid();
    } else {
      this.$emit('update:line-items', this.lineItems);
      if(this.matterWorkModule && this.matterWorkModule.selectMatter && this.lineItems) {
        this.$set(this.matterWorkModule.selectMatter, 'LineItems',this.lineItems);
      }
    }    
  }

  updateSelectedMatterLineItems() {
    this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.PhaseAnalysisItem);
    if(this.matterWorkModule && this.matterWorkModule.selectMatter && this.lineItems) {
        this.$set(this.matterWorkModule.selectMatter, 'LineItems',this.lineItems);
    }
  }


  startIndexSelection: number = -1;
  endIndexSelection: number = -1;
  prevEndval: number = -1;
  fromDragBack: boolean = false;

  incrementOrDecrement(isFromTop: boolean, bigger: number, smaller: number,callback: any){
    if(isFromTop) {
      for(var i = smaller; i <= bigger; i++){
        callback(i);
      }
    }
    else{
      for(var i = bigger; i >= smaller; i--){
        callback(i);
      }
    }
  }
  cellHoverChanged(e: any): void {  
    let dragBack = false;
    let isIncremental = true;
    if (e.event.buttons == 2 && (e.event.type == "mouseover" || !this.draggingSelect)) {
      if (!e.row) {
          return;
      }

      if(this.startIndexSelection == -1) {
        this.startIndexSelection = e.row.rowIndex;
        if(this.endIndexSelection == -1) {
          this.endIndexSelection = e.row.rowIndex;
        }
      }
      else {
        if(this.endIndexSelection != -1) {
          if(this.startIndexSelection == e.row.rowIndex) {
            dragBack = true;
          }
          else if(this.startIndexSelection > this.endIndexSelection) {
            if(this.endIndexSelection < e.row.rowIndex){
              dragBack = true;
            }
            else {
              dragBack = false;
            }
          }
          else if(this.startIndexSelection < this.endIndexSelection) {
            if(this.endIndexSelection > e.row.rowIndex){
              dragBack = true;
            }
            else if(this.endIndexSelection < e.row.rowIndex) {
              dragBack = false;
            }
          }
        }
       
        this.endIndexSelection = e.row.rowIndex;
      }

      
      this.draggingSelect = true;
      isIncremental = (this.startIndexSelection < this.endIndexSelection);
      var smaller = Math.min(this.endIndexSelection, this.startIndexSelection);
      var bigger = Math.max(this.endIndexSelection, this.startIndexSelection);

      if(this.prevEndval != -1) {
        isIncremental = (this.prevEndval < this.endIndexSelection);
        smaller =  Math.min(this.endIndexSelection, this.prevEndval);
        bigger = Math.max(this.endIndexSelection, this.prevEndval);
      }

      var smallerIterate = smaller == -1 ? bigger : smaller;
      if(this.prevEndval != this.endIndexSelection) {
      this.incrementOrDecrement(isIncremental, bigger, smaller, (i: number) => {
         if(i != this.prevEndval || (dragBack || this.fromDragBack)) {
          let selectedRowKeys: any[] = e.component.getSelectedRowKeys();
          let toSet = false;
          let rowKey = e.component.getKeyByRowIndex(i);
          let previouslySet = this.draggingSelection.get(rowKey);
          

           if (this.draggingSelectOrDeselect == null) {
            if (selectedRowKeys.includes(rowKey)) {
                this.draggingSelectOrDeselect = false;
            } 
            else {
                this.draggingSelectOrDeselect = true;
            }
          }

    
          if(dragBack) {
            let firstSetKey = e.component.getKeyByRowIndex(this.startIndexSelection);
            let firstSet = this.draggingSelection.get(firstSetKey);
            
            toSet = !firstSet;
          }
          else {
            if(previouslySet != null) {
              toSet = !previouslySet;
            }
            else {
              toSet = this.draggingSelectOrDeselect;
            }
          }
            
          this.setRowFromHover(e.component, rowKey, toSet);
        }
      })
        
      if(dragBack) {
        this.fromDragBack = true;
      }
      else {
        this.fromDragBack = false;
      }

      dragBack = false;
      this.prevEndval = this.endIndexSelection;
      } 
    } else if (this.draggingSelect && e.event.buttons == 0) {
          this.prevEndval = -1;
          dragBack = false;
          this.draggingSelect = false;
          this.draggingSelectOrDeselect = null;
          this.draggingSelection.clear();
          this.draggingLastSet = "";
          this.startIndexSelection = -1;
          this.endIndexSelection = -1;
          this.fromDragBack = false;
      
    }

    this.toggleLineItemTotalTooltip(e);
  }

  toggleLineItemTotalTooltip(e: any) {
    if(e.rowType === 'data' && e.value === e.data.LineItemTotal && e.row.isSelected) {
      if(e.eventType == "mouseover") {
        if(e.row) {
          let selectedRowsTotal = _.sum(e.component.getSelectedRowsData().map((r: any) => r.LineItemTotal));
          e.cellElement.title = (this.$options.filters as any).currency(selectedRowsTotal);
        }
      }
      else {
        e.cellElement.title = "";
      }
    }    
  }

  setRowFromHover(component: any, rowKey: string, set: boolean) {
    if (set) {
        component.selectRows([rowKey], true);
    } 
    else {
        component.deselectRows([rowKey], true);
    }

    this.draggingSelection.set(rowKey, set);
    this.draggingLastSet = rowKey;
  }

  checkGridScrollPosition(e: any) {
      //var gridHeight = e.element.offsetHeight;
      //var loc = e.event.clientX;

      //if (gridHeight - 100 < loc) {
      //    var scrollable = this.dxDataGrid.getScrollable();
      //    scrollable.scrollBy(100);
      //}
  } 
  
  prepareContextMenu(e: any): void {
    if (e.target === 'content' && e.row &&  e.row.rowType === 'data' && !this.draggingSelect) {      
      let preserve: boolean = false;
      let selectedRowKeys: any[] = e.component.getSelectedRowKeys();

      if (selectedRowKeys.includes(e.row.key)) {
        preserve = true;
      }

      e.component.selectRows([e.row.key], preserve);
      e.items = this.getContextMenuItems();
    
      if (e.column.dataField === 'AgentName') {
        e.items.push({
          text: 'View Agent Setup',
          onItemClick: () => this.showAgentInfoEditWindow(e.row.data.AgentName)
        });

        e.items = e.items.concat(this.getContextMenuAgentJurisdiction(e))
      } else if (e.column.dataField === 'LastAssignedBy') {
        e.items.push({
          text: 'View Phase History',
          onItemClick: () => this.showPhaseHistory(e.row.data)
        });
      }

      this.isContextShow = true;
      this.dialogStateChanged();
    }

    e.event.preventDefault();
  }

  private showPhaseHistory(lineItem: ManualCodeInvoiceLineItemDto) {
    this.phaseHistoryLineItemId = lineItem.InvoiceLineItemId;
    this.showingPhaseHistory = true;
  }

  private getCommonPhaseTypes(): PhaseTypeDto[] {
    return this.phaseTypes
      .filter(p => p.SecondaryPhaseOrder !== null)
      .sort((a, b) => {
        if (a.SecondaryPhaseOrder === b.SecondaryPhaseOrder) return 0;
        if (a.SecondaryPhaseOrder === null) return 1;
        if (b.SecondaryPhaseOrder === null) return -1;
        return a.SecondaryPhaseOrder < b.SecondaryPhaseOrder ? -1 : 1;
      });
  }

  private getOtherPhaseTypes(): PhaseTypeDto[] {
    return this.phaseTypes.filter(p => p.SecondaryPhaseOrder === null).sort((a, b) => a.PhaseOrder - b.PhaseOrder);
  }

  private getContextMenuItem(phaseType: PhaseTypeDto): ContextMenuItem {
    return {
      text: phaseType.PhaseName,
      rgbHex: phaseType.RgbHex,
      template: 'contextMenuItem',
      onItemClick: () => this.assignPhase(phaseType.PhaseTypeId)
    };
  }

  private assignPhase(phaseTypeId: number | null): void {
    this.$emit('assign-phase', phaseTypeId);    
  }
    
  private getContextMenuExempt() {
    let isExempt = true;
    let selectedRows: Array<any> = ((this.$refs.manualCodingDataGrid as any).$refs.dxDataGrid as any)
        .instance.getSelectedRowsData();
    
    for(let i = 0; i < selectedRows.length; i++) {
      let row = selectedRows[i];
      if(row.IsExempt == false){
          isExempt = true;
          break;
       }
       else{
         isExempt = false;
       }
    }
    if (isExempt){
        return {
          text: 'Make Row(s) Exempt',
          template: 'contextMenuItem',
          onItemClick: () => this.$emit('set-exempt-row', true)
        };
    }
    else{
        return {
          text: 'Make Row(s) Unexempt',
          template: 'contextMenuItem',
          onItemClick: () => this.$emit('set-exempt-row', false)
        };
    }
  }

  private getContextMenuChangeCountry() {
    return { 
      text: 'Change Rows\' Country',
      template: 'contextMenuItem',
      onItemClick: () => {
        this.updateLineItemCountry();
      }
    };
  }

  private getContextMenuChangeMatterName() {
    return { 
      text: 'Change Matter Name',
      template: 'contextMenuItem',
      onItemClick: () => {
        this.updateLineItemMatterName();
      }
    };
  }

  private getContextMenuAgentJurisdiction(e: any) {
    let items = [];

    let inJurisdictionDto: UpdateClientAgentJurisdictionDto = {
      ClientId: this.clientId,
      AgentId:  e.row.data.AgentId,
      CountryCode: this.selectedMatter.CountryCode,
      InJurisdiction: true,
      JurisdictionFree: false
    };

    let inJurisdictionItem = {
      text: 'Set In Jurisdiction for ' + this.selectedMatter.CountryCode,
      textColor: 'DarkGreen',
      template: 'contextMenuItem',      
      onItemClick: () => this.updateClientAgentJurisdiction(inJurisdictionDto)      
    };


    let outJurisdictionDto: UpdateClientAgentJurisdictionDto = {
      ClientId: this.clientId,
      AgentId:  e.row.data.AgentId,
      CountryCode: this.selectedMatter.CountryCode,
      InJurisdiction: false,
      JurisdictionFree: false
    };

    let outJurisdictionItem = {
      text: 'Set Out of Jurisdiction for ' + this.selectedMatter.CountryCode,
      textColor: 'DarkBlue',
      template: 'contextMenuItem',
      onItemClick: () => this.updateClientAgentJurisdiction(outJurisdictionDto)   
    };
    
    let jurisdictionFreeDto: UpdateClientAgentJurisdictionDto = {
      ClientId: this.clientId,
      AgentId:  e.row.data.AgentId,
      CountryCode: this.selectedMatter.CountryCode,
      InJurisdiction: false,
      JurisdictionFree: true
    };

    let jurisdictionFreeItem = {
      text: 'Set Jurisdiction Free',
      textColor: 'DarkGray',
      template: 'contextMenuItem',
      onItemClick: () => this.updateClientAgentJurisdiction(jurisdictionFreeDto)   
    };

    if(e.row.data.AgentJurisdiction == null) {
      items.push(inJurisdictionItem);
      items.push(outJurisdictionItem);
      items.push(jurisdictionFreeItem);
    }
    else if(e.row.data.AgentJurisdictionFree) {
      items.push(inJurisdictionItem);
      items.push(outJurisdictionItem);
    }
    else if(e.row.data.AgentJurisdiction) {      
      items.push(outJurisdictionItem);
      items.push(jurisdictionFreeItem);
    }
    else {
      items.push(inJurisdictionItem);
      items.push(jurisdictionFreeItem);
    }

    return items;
  }

  private updateClientAgentJurisdiction(jurisdictionDto: UpdateClientAgentJurisdictionDto) {
    this.clientAgentService.updateClientAgentJurisdiction(jurisdictionDto)
      .then(result => {
        this.refreshDataGrid();
      })
      .finally(() => {
        this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.PhaseAnalysisItem);
      });
  };

  private updateLineItemCountry() {    
    this.selectedLineItems = ((this.$refs.manualCodingDataGrid as any).$refs.dxDataGrid as any)
      .instance.getSelectedRowsData();    
    this.showingUpdateCountry = true;
  }  

  private updateLineItemMatterName() {
    this.selectedLineItems = ((this.$refs.manualCodingDataGrid as any).$refs.dxDataGrid as any)
      .instance.getSelectedRowsData();    
    this.showingUpdateMatterName = true;
  }
  
  private clientAgentInfo: ClientAgentInfoDto = new ClientAgentInfoDto();
  private showAgentInfoEditWindow(agentName: string) {
    this.clientAgentService.getExistingClientAgentData(this.selectedMatter.ClientId, agentName)
      .then(result => {
        this.clientAgentInfo = result;
        this.clientAgentInfo.Client = {
          ClientId: this.selectedMatter.ClientId,
          ClientName: this.selectedMatter.ClientName
        };
        this.showingAgentInfo = true;
      });
  }

  private readonly auditorNotesClass: string = "auditor-notes";
  private readonly privateNotesClass: string = "private-notes";

  private getNotesClass(row: any) {
    let notesClass = "default-notes";

    if (row.AnalysisReportPrintDataOptions === AnalysisReportPrintDataOptionsType.SingleLineItem ||
        row.AnalysisReportPrintDataOptions === AnalysisReportPrintDataOptionsType.EntirePhase ||
        row.AnalysisReportPrintDataOptions === AnalysisReportPrintDataOptionsType.EntireCase) {
      notesClass = this.auditorNotesClass;
    } else if (!String.isNullOrEmpty(row.AuditorNotesReportLanguage) || !String.isNullOrEmpty(row.PrivateAuditorNotes)) {
      notesClass = this.privateNotesClass;
    }

    return notesClass;
  }

  private getInfractionClass(row: any): string {
    let result = "no-infraction";

    if (row.HasConfirmedInfraction) {
      result = "has-confirmed-infraction";
    } else if (row.HasSystemGeneratedInfraction){
      result = "has-system-generated";
    }

    return result;
  }

  private notesLineItem: any = {};
  userFontSize: number = 12; //standard font size for data grid
  showingNotes: boolean = false;
  showingInfractions: boolean = false;
  showingAgentInfo: boolean = false;
  showingPhaseHistory: boolean = false;
  showingUpdateCountry: boolean = false;
  showingUpdateMatterName: boolean = false;
  hoveredLineItem: ManualCodeInvoiceLineItemDto | null = null;
  hoveredRowPhaseColor: string = '';
  private static readonly defaultPhaseColor: string = 'rgb(240, 240, 240)';

  @Emit()
  dialogStateChanged(): MatterWorkLineItemsDialogState {    
    return {
      showingContextMenu: this.isContextShow,
      showingInfractions: this.showingInfractions,
      showingInfractionsPopover: this.popoverVis,
      showingNotes: this.showingNotes,
      showingColumnChooser: false,
      showingAgentInfo: this.showingAgentInfo,
      showingPhaseHistory: this.showingPhaseHistory,
      showingUpdateCountry: this.showingUpdateCountry,
      showingUpdateMatterName: this.showingUpdateMatterName
    };
  }

  private enableLoadPanel() {
    this.setLoadPanelEnabled(true);
  }

  private disableLoadPanel() {
    this.setLoadPanelEnabled(false);
  }

  private setLoadPanelEnabled(value: boolean) {
    let currentValue = this.dxDataGrid.option('loadPanel.enabled');
    if (value !== currentValue) {
      this.dxDataGrid.option('loadPanel.enabled', value);
    }
  }

  hidingNotes(): void {
    this.showingNotes = false;
    this.dialogStateChanged();
    setTimeout(() => {
      this.refreshDataGrid();
    }, 1000);
  }

  hidingInfractions(e: { isCancelled: boolean, lineItem?: ManualCodeInvoiceLineItemDto, reloadInfractionTypes: boolean }): void {
    this.showingInfractions = false;
    if (!e.isCancelled && e.lineItem) {
      this.updateLineItems([e.lineItem]);
    }

    if (e.reloadInfractionTypes) {
      this.infractionService.GetAllInfractionTypes()
        .then(response => {
          this.infractionTypes = response;
        });
    }

    this.dialogStateChanged();
  }

  hidingPopover(e: { isCancelled: boolean, lineItem?: ManualCodeInvoiceLineItemDto }): void {
    if (!e.isCancelled && e.lineItem) {
      this.updateLineItems([e.lineItem]);
    }

    this.enableLoadPanel();
    this.dialogStateChanged();
  }

  hidingAgentInfo() {    
    this.showingAgentInfo = false;
    this.refreshDataGrid();
  }

  hidingPhaseHistory() {
    this.showingPhaseHistory = false;
    this.phaseHistoryLineItemId = '';
  }

  hidingUpdateCountry(lineItemIds: Guid[], newCountryCode: string) {
    this.showingUpdateCountry = false;
    if (lineItemIds.length > 0) {    
      let remainingLineItems = this.selectedMatter.LineItems.filter(li => !lineItemIds.some(id => id == li.InvoiceLineItemId));      

      if (remainingLineItems.length == 0) {
        this.selectedMatter.IsDeleted = true;
        this.$root.$emit('matter-deleted', this.selectedMatterId)
      }
      else {
        this.selectedMatter.LineItems = remainingLineItems;
        this.selectedMatter.LineItemTotals = remainingLineItems.reduce(function(sum, li) { return sum + li.LineItemTotal; }, 0);
        this.selectedMatter.LineItemTotalsService = remainingLineItems
          .filter(li => li.FeeType == FeeTypeNameEnum.Service)
          .reduce(function(sum, li) { return sum + li.LineItemTotal; }, 0);
        this.selectedMatter.AllLineItemsConfirmed = this.selectedMatter.LineItems.every(li => li.Confirmed);
        this.selectedMatter.Agents = this.selectedMatter.LineItems.map(li => li.AgentName);
        this.selectedMatter.Phases = this.selectedMatter.LineItems.map(li => li.AssignedPhaseName);     

        this.refreshDataGrid();
        this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.All);
      }      

      // Update the target matter if it is in this MatterWork
      this.$root.$emit('updatetargetmatter', this.selectedMatter.ClientMatterId, newCountryCode)
    }
  }

  hidingUpdateMatterName(lineItemIds: Guid[], newMatter: MatterDto) {
    this.showingUpdateMatterName = false;      

    if (newMatter != null && lineItemIds.length > 0) {    
      let remainingLineItems = this.selectedMatter.LineItems.filter(li => !lineItemIds.some(id => id == li.InvoiceLineItemId));      

      if (remainingLineItems.length == 0) {
        this.selectedMatter.IsDeleted = true;
        this.$root.$emit('matter-deleted', this.selectedMatterId)
      }
      else {
        this.selectedMatter.LineItems = remainingLineItems;
        this.selectedMatter.LineItemTotals = remainingLineItems.reduce(function(sum, li) { return sum + li.LineItemTotal; }, 0);
        this.selectedMatter.LineItemTotalsService = remainingLineItems
          .filter(li => li.FeeType == FeeTypeNameEnum.Service)
          .reduce(function(sum, li) { return sum + li.LineItemTotal; }, 0);
        this.selectedMatter.AllLineItemsConfirmed = this.selectedMatter.LineItems.every(li => li.Confirmed);
        this.selectedMatter.Agents = this.selectedMatter.LineItems.map(li => li.AgentName);
        this.selectedMatter.Phases = this.selectedMatter.LineItems.map(li => li.AssignedPhaseName);     

        this.refreshDataGrid();
        this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.All);
      }      

      // Update the target matter if it is in this MatterWork
      this.$root.$emit('updatetargetmatter', newMatter.MatterName, newMatter.CountryCode)
    }
  }

  private getIdForPopover(rowData: any): string {
    return 'target-' + rowData.rowIndex;
  }

  private popoverTimeout: number | undefined;

  private hidePopover(): void {
    if (this.popoverTimeout) {
      clearTimeout(this.popoverTimeout);
      this.popoverTimeout = undefined;
    }

    this.popoverVis = false;
  } 

  private showPopOver(e: any): void {
    if (this.popoverVis) {
      return;
    }

    if (this.popoverTimeout) {
      clearTimeout(this.popoverTimeout);
    }

    this.popoverTimeout = setTimeout(() => {
      this.disableLoadPanel();
      this.hoveredLineItem = e.row.data;
      this.popoverTarget = '#target-' + e.rowIndex;
      let phaseType = this.phaseTypes.find(t => t.PhaseTypeId === e.row.data.AssignedPhaseTypeId);
      this.hoveredRowPhaseColor = phaseType ? phaseType.RgbHex : MatterWorkLineItems.defaultPhaseColor;
      this.popoverVis = true;
      this.dialogStateChanged();
    }, 500);
  }

  private openInfractionForm(e: any): void {
    this.popoverVis = false;
    this.hoveredLineItem = e.row.data;
    this.popoverTarget = '#target-' + e.rowIndex;
    let phaseType = this.phaseTypes.find(t => t.PhaseTypeId === e.row.data.AssignedPhaseTypeId);
    this.hoveredRowPhaseColor = phaseType ? phaseType.RgbHex : MatterWorkLineItems.defaultPhaseColor;
    this.showingInfractions = true;
    this.dialogStateChanged();
  }

  private openNotesForm(row: any): void {  
    this.notesLineItem = row;
    this.showingNotes = true;
    this.dialogStateChanged();
  }

  openNotesKeyboard(): void {
    let selectedRows: Array<any> = ((this.$refs.manualCodingDataGrid as any).$refs.dxDataGrid as any)
      .instance.getSelectedRowsData();
    if (selectedRows.length > 0) {
      this.openNotesForm(selectedRows[selectedRows.length - 1]);
    }
  } 

  onContentReady(e: any): void {
      var columnChooserView = e.component.getView("columnChooserView");
      if (!columnChooserView._popupContainer) {
          columnChooserView._initializePopupContainer();
          columnChooserView.render();
          columnChooserView._popupContainer.on("hiding", () =>
              {
                this.dialogStateChanged();
              });
      }
      document.addEventListener('mousedown', this.onMousedown);
      setTimeout(() => this.scrollToTop(), 100);
  }

  destroyed() {
    document.removeEventListener('mousedown', this.onMousedown);
  }

  onMousedown(e: MouseEvent) {
    if (this.isContextShow) {
      this.isContextShow = false;
      this.dialogStateChanged();
    }
  }

  async getFontSizeFromUserSettings() {
    let userPref = await this.userSettingsService.getUserSettings(UserSettingReportName.UserPreference,
                    UserSettingName.DataTableFontSize);

    if(userPref && userPref[0]) {
      this.userFontSize = +(userPref[0].Value);
    }
  }

  handleUserPreferenceChangeEvent(value : number) {
      this.userFontSize = value;
  }
  onCellPrepared(e: any) {
    if(e.rowType === 'data' && e.column.dataField === 'LastAssignedBy') {
      e.cellElement.title = e.text;
    }
    else if(e.rowType === 'data' && this.coloredColumns.includes(e.column.dataField)) {         
      let phaseType = this.phaseTypes.filter(t => t.PhaseTypeId == e.row.data.AssignedPhaseTypeId)[0];
      if (phaseType) {
        e.cellElement.style['background-color'] = phaseType.RgbHex;
      }
    }
    else if(e.rowType === 'data' && e.column.dataField == 'AgentName') {        
      if (e.row.data.AgentJurisdictionFree) {
        e.cellElement.style['color'] = 'DarkGray';
      }
      else if(e.row.data.AgentJurisdiction == null) {
        e.cellElement.style['color'] = 'Red';
      }
      else if(e.row.data.AgentJurisdiction) {
        e.cellElement.style['color'] = 'DarkGreen';
      }
      else {
        e.cellElement.style['color'] = 'DarkBlue';
      }      
    }    
  }

  onCellDoubleClick(e: any) {    
    if(e.rowType === 'data' && e.column.dataField === 'FeeType') {    
      this.selectedLineItem.lineItemId = e.data.InvoiceLineItemId            
      this.selectedLineItem.previousFeeType = e.value;      

      switch(e.value) {
        case FeeTypeNameEnum.Service: 
          e.data.FeeType = FeeTypeNameEnum.Expense;
          this.dxDataGrid.cellValue(e.rowIndex, 'FeeType', FeeTypeNameEnum.Expense);
          break;
        
        case FeeTypeNameEnum.Expense:
          e.data.FeeType = FeeTypeNameEnum.Translation;
          this.dxDataGrid.cellValue(e.rowIndex, 'FeeType', FeeTypeNameEnum.Translation);
          break;

        case FeeTypeNameEnum.Translation:
          e.data.FeeType = FeeTypeNameEnum.Service;
          this.dxDataGrid.cellValue(e.rowIndex, 'FeeType', FeeTypeNameEnum.Service);
          break;
      }    
      this.saveCellEdit();
    }
  }

  listOfLineItems: any;
  currentlyFocusedPhase: string | undefined;
  clearFocus() {
    this.listOfLineItems = undefined;
    this.customDataSource = [];
    this.currentlyFocusedPhase = undefined;
  }
  
  async handleFocusedPhaseTypeEvent(e: any) {
    if(!e)
    {
      this.clearFocus();
    }
    else {
      this.currentlyFocusedPhase = e;
      this.listOfLineItems = this.listOfLineItems || await this.dxDataGrid.getDataSource().store().load();
      let focusedLineItems = this.listOfLineItems.filter((item :any) => item.AssignedPhaseName == (e === "Unassigned" ? null:e));
      let recordsToBeIncluded: any[] = [];

      //also handles when same service date
      focusedLineItems.forEach((item :any) => {
        let ind = _.findIndex(this.listOfLineItems, (lineItem : any) => item.InvoiceLineItemId == lineItem.InvoiceLineItemId);
        let backInd = ind + 2;
        let frontInd = ind - 2;

        for(var i = 2; i > 0 ; i--){
          let backItm = backInd < this.listOfLineItems.length ? this.listOfLineItems[backInd] : undefined;
          let frontItm = frontInd >= 0 ? this.listOfLineItems[frontInd] : undefined;

          if(backItm && backItm.AssignedPhaseName != e) {
            recordsToBeIncluded.push(backInd);
          }
          if(frontItm && frontItm.AssignedPhaseName != e) {
            recordsToBeIncluded.push(frontInd);
          }

          backInd--;
          frontInd++;
        }

        recordsToBeIncluded.push(ind);
      });

      //get data per index
      let newDataSource: any[] = [];
      
      _.uniqBy(recordsToBeIncluded, item => item)
      .sort((a,b) => a - b)
      .forEach((indx : number) => {
        newDataSource.push(this.listOfLineItems[indx]);
      });

      if(newDataSource && newDataSource.length == 0) {
        this.clearFocus();
      }
      else {
        this.customDataSource = newDataSource;
      }
    }

    this.refreshDataGrid();
  }

  async mounted(): Promise<void> {
    this.$root.$on("user-preference", this.handleUserPreferenceChangeEvent);
    this.$root.$on("focused-phase-type", this.handleFocusedPhaseTypeEvent);
    await this.getFontSizeFromUserSettings();

    this.infractionTypes = await this.infractionService.GetAllInfractionTypes();
  }

  private lastAssignedByTemplate(container: any, options: any): void {
    const value: string = options.data.LastAssignedBy;    

    container.textContent = value.split(' ').map(s => s[0]).join('').toUpperCase();    
  }

  private servTemplate(container: any, options: any): void {
    const serviceDate = moment(options.data.ServiceDate).format("MM-DD-YYYY");
    
    container.textContent = serviceDate;
    container.title = serviceDate;    

    const inCurrentBatch: boolean = this.activeBatchIds && this.activeBatchIds.some(b => b === options.data.BatchId);

    container.style.fontWeight = inCurrentBatch ? "bold" : "normal";
    container.style.fontSize = `${(this.userFontSize + 2)}px`;
    container.style.textDecoration = "none";    
  }

  private amountTemplate(container: any, options: any): void {
    const num = parseFloat(options.data.LineItemTotal);

    if (!isNaN(num)) {
      const lineItemTotal = num.toLocaleString(undefined, {
         style: 'currency',
        currency: 'USD'
      });

      container.textContent = lineItemTotal;
      container.title = lineItemTotal;
    }
    
    const inCurrentBatch: boolean = this.activeBatchIds && this.activeBatchIds.some(b => b === options.data.BatchId);

    container.style.fontWeight = inCurrentBatch ? "bold" : "normal";
    container.style.fontSize = `${(this.userFontSize + 2)}px`;
    container.style.textDecoration = options.data.IsExempt ? "line-through" : "none";
  }

  private invTemplate(container: any, options: any): void {
    const invoiceNumber = options.data.InvoiceNumber;
    container.textContent = invoiceNumber;
    container.title = invoiceNumber;

    const inCurrentBatch: boolean = this.activeBatchIds && this.activeBatchIds.some(b => b === options.data.BatchId);

    container.style.fontWeight = inCurrentBatch ? "bold" : "normal";
    container.style.fontSize = `${(this.userFontSize + 2)}px`;
    container.style.textDecoration = "none";
  }

  private descTemplate(container: any, options: any): void {
    container.textContent = options.data.Description;
    if(options.data.FeeType !== FeeTypeNameEnum.Service) {
      container.style.paddingLeft = "25px";
    }    
  }

  beforeDestroy() {
    this.lineItems.length=0;
    this.detachHandlers();
    this.$root.$off("user-preference", this.handleUserPreferenceChangeEvent);
    this.$root.$off("focused-phase-type", this.handleFocusedPhaseTypeEvent);
  }

  detachHandlers() {
    if(this.dxDataGrid) {
      this.dxDataGrid.off("cellDblClick");
      this.dxDataGrid.off("cellHoverChanged");
      this.dxDataGrid.off("cellPrepared");
      this.dxDataGrid.off("contentReady");
      this.dxDataGrid.off("contextMenuPreparing");
      this.dxDataGrid.dispose();
    }
  }

  scrollToNewestRow() {
    this.dxDataGrid.clearSorting();
    let latestDate = this.lineItems.reduce((a, b) => { 
        return a.DateCreated > b.DateCreated ? a : b 
    }).DateCreated;
    let lineItem = this.lineItems.find(li => li.DateCreated == latestDate);
        
    if(lineItem != null) {
      let rowElement = this.dxDataGrid.getRowElement(this.dxDataGrid.getRowIndexByKey(lineItem.InvoiceLineItemId));
      let scrollView = this.dxDataGrid.getScrollable();
      if(rowElement) {        
        scrollView.scrollToElement(rowElement);
      }                  
    }    
  }

  scrollToTop() {
    if (this.selectedMatterChanged) {
      this.selectedMatterChanged = false;
      let scrollable = this.dxDataGrid.getScrollable();
      if (scrollable != undefined) {
        scrollable.scrollTo(0);      
      }
    }
  }
}
